import { styled } from 'styled-components'
import { Block, Text } from 'suomifi-ui-components'

export const InfoRow = styled(Block).attrs({ variant: 'div' })`
  flex-direction: row;
  display: flex;

  margin-top: ${({ theme }) => theme.spacing.m};
`

export const InfoColumn = styled(Block).attrs({ variant: 'div' })`
  display: flex;
  width: ${({ width }) => width || '50%'};
  flex-direction: column;
  & > *:last-child {
    margin-top: ${({ theme }) => theme.spacing.m};
  }
`

export const TextBlock = styled(Block)`
  display: flex;
  flex-direction: column;
`

export const PriceRowContainer = styled(TextBlock)`
  padding: ${({ theme }) => theme.spacing.m} 0;
`

export const CertificatePriceTotal = styled(Block)`
  padding-top: ${({ theme }) => theme.spacing.m};
  margin-top: ${({ theme }) => theme.spacing.m};
  border-top: 1px solid ${({ theme }) => theme.colors.blackLight1};
`

export const CertificatePriceRow = styled(Block).attrs({ variant: 'div' })`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
`

export const TextNoWrap = styled(Text)`
  white-space: nowrap;
`
